module.exports = __webpack_public_path__ + "img/Opening_the_Tube.2e784af2.png";